import { onMounted, onUnmounted, watch } from 'vue';
import { useBackendFetch } from '@/fetch';
import { useStore } from '@/stores/main';

const HEARTBEAT_INTERVAL_MS = 30_000;

export function useStudentActivityHeartbeat() {
  const store = useStore();
  let intervalId: number | null = null;
  let requestInProgress = false;

  const sendHeartbeat = async () => {
    if (
      requestInProgress ||
      document.hidden ||
      !store.loggedIn ||
      !store.token
    ) {
      return;
    }

    requestInProgress = true;
    try {
      await useBackendFetch('/activity/heartbeat').post();
    } catch {
      // Presence is best-effort and must never interrupt the student's work.
    } finally {
      requestInProgress = false;
    }
  };

  const start = () => {
    if (intervalId !== null) return;
    void sendHeartbeat();
    intervalId = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
  };

  const stop = () => {
    if (intervalId === null) return;
    window.clearInterval(intervalId);
    intervalId = null;
  };

  const sync = () => {
    if (store.loggedIn && store.token) start();
    else stop();
  };

  const handleVisibilityChange = () => {
    if (!document.hidden) {
      sync();
      void sendHeartbeat();
    }
  };

  const stopWatching = watch(
    () => [store.loggedIn, store.token],
    sync,
  );

  onMounted(() => {
    sync();
    document.addEventListener('visibilitychange', handleVisibilityChange);
  });

  onUnmounted(() => {
    stop();
    stopWatching();
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  });
}
